export default {
  titles: {
    default: 'Lembrete de pedido agendado!',
    external_delivery: 'Estafeta atribuído!',
  },
  labels: {
    pickup: 'Recolha: {{time}}',
    serve: 'Serviço: {{time}}',
    preparation_time: 'Tempo de preparação: {{time}} min',
  },
  buttons: {
    confirm: 'Começar a preparar agora',
    print_and_confirm: 'Imprimir e começar a preparar agora',
  },
  toasts: {
    something_went_wrong: 'Algo correu mal, por favor tente novamente',
  },
};
